export const colors: string[] = [
    'violet',
    'lightgreen',
    'deepskyblue',
    'lightcoral',
]